/* NIBLaunchDialogComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./NIBLaunchDialogRenderer"); //jshint ignore:line

class NIBLaunchDialogComponent extends EventEmitter {
    constructor(userSession, opts) {
        super();
        //required
        this._userSession = userSession;
        this._renderer = new Renderer(this);

        //View Options
        this._title = _.get(opts, "title", "Provide Details");

        //Other Options

        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        if (this._renderer) {
            return this._renderer.shutdown().then(() => {
                this._renderer = undefined;
            });
        } else {
            return Promise.resolve();
        }
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    set "$teve.ui.context"(cntxt) {
        //jshint ignore:line
        this._userFeedbackContext = cntxt;
    }
    get title() {
        return this.getTitle();
    }
    getTitle() {
        return this._title;
    }
    get userSession() {
        return this.getUserSession();
    }
    getUserSession() {
        return this._userSession;
    }
    updateNIBProgress(progressObj) {
        this.emit("UpdateNIBProgress", progressObj);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /* START PUBLIC ACTION METHODS */
    /*******************************************/
    confirm(value) {
        this._userFeedbackContext.resolve(value);
    }
    reject(e) {
        this._userFeedbackContext.reject(e);
    }
    /*******************************************/
    /* END PUBLIC ACTION METHODS */
    /*******************************************/
}
module.exports = NIBLaunchDialogComponent;
